module.exports = "/images/plan-starter-icon.svg?2dab2242c6f11c77a05dba5bea8b5883";